import { modifier } from 'ember-modifier';

const imageFadeIn = modifier((element: HTMLImageElement) => {
  const fallbackSrc = element.dataset['fallbackSrc'];

  const reveal = () => {
    element.classList.remove('opacity-0');
    element.classList.add('opacity-100');
  };

  const onError = () => {
    if (
      fallbackSrc &&
      element.currentSrc !== fallbackSrc &&
      element.src !== fallbackSrc
    ) {
      element.src = fallbackSrc;
      return;
    }
    reveal();
  };

  if (element.complete) {
    reveal();
    return;
  }

  element.addEventListener('load', reveal, { once: true });
  element.addEventListener('error', onError);

  return () => {
    element.removeEventListener('load', reveal);
    element.removeEventListener('error', onError);
  };
});

export default imageFadeIn;
